/*
  ============================================================
  FILE: ctx-filter-groups.js
  LOCATION: assets/ctx-filter-groups.js

  Opens and closes the family groups inside the Product Type filter, and runs the
  search box above them.

  WHY A SEARCH BOX AT ALL

  42 values is too many to scan even once they are grouped, and someone who knows they
  want "Kettlebells" should not have to guess that it is filed under Free Weights.
  Typing shows matches from every group at once and hides the groups that have none.

  Clearing the box puts the groups back exactly as they were, including which ones were
  open because a filter is active - so searching never loses your place.
  ============================================================
*/
(function () {
  'use strict';

  function initGroups(root) {
    root.querySelectorAll('.ctx-cg__filter-group-toggle').forEach(function (btn) {
      if (btn.dataset.ctxBound) return;
      btn.dataset.ctxBound = '1';

      btn.addEventListener('click', function (e) {
        /* The whole sidebar is a form that submits on change; a button inside it
           would post the page if left to its default. */
        e.preventDefault();
        var group = btn.closest('.ctx-cg__filter-group');
        if (!group) return;
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initSearch(root) {
    root.querySelectorAll('[data-ctx-filter-search]').forEach(function (input) {
      if (input.dataset.ctxBound) return;
      input.dataset.ctxBound = '1';

      var body = input.closest('.ctx-cg__filter-body');
      if (!body) return;

      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();

        if (!q) {
          body.classList.remove('is-searching');
          body.querySelectorAll('li[hidden]').forEach(function (li) { li.removeAttribute('hidden'); });
          body.querySelectorAll('.ctx-cg__filter-group[hidden]').forEach(function (g) { g.removeAttribute('hidden'); });
          return;
        }

        body.classList.add('is-searching');

        body.querySelectorAll('.ctx-cg__filter-group').forEach(function (group) {
          var shown = 0;
          group.querySelectorAll('li').forEach(function (li) {
            var label = li.querySelector('.ctx-cg__filter-value');
            var text = label ? label.textContent.toLowerCase() : '';
            var hit = text.indexOf(q) !== -1;
            if (hit) { li.removeAttribute('hidden'); shown++; }
            else { li.setAttribute('hidden', ''); }
          });
          /* A family with no matches is noise while searching. */
          if (shown) { group.removeAttribute('hidden'); }
          else { group.setAttribute('hidden', ''); }
        });
      });

      /* Escape clears rather than closing the drawer around it. */
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) {
          e.stopPropagation();
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  function init() {
    initGroups(document);
    initSearch(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The filter sidebar is re-rendered after every filter change, which throws away the
     bound elements. Re-bind whatever appears. */
  if (window.MutationObserver) {
    new MutationObserver(function () { init(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
